<template>
  <div>
    <base-title
      title="Cadastro - Foody Delivery"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-register">
      <div class="header">
        <div class="d-flex justify-between align-center w-100">
          <p class="title">Informações</p>
          <div class="toggle" @click="toggle()">
            <input
              type="checkbox"
              id="toggle-checkbox"
              v-model="formData.active"
            />

            <div
              class="toggle-control"
              :class="formData.active ? 'toggleOn' : 'toggleOff'"
            >
              <span class="control">
                <span>{{ formData.active ? 'Ativado' : 'Desativado' }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="form">
        <base-input
          :valid="!formErrors.apiToken"
          v-model="formData.apiToken"
          placeholder="Token da API"
          class="w-100"
          @focus="!formErrors.apiToken"
          @input="(value) => removeEmptySpaces('apiToken', value)"
        />

        <base-input
          :valid="!formErrors.triggerToken"
          v-model="formData.triggerToken"
          placeholder="Token de gatilho"
          class="w-100"
          @input="(value) => removeEmptySpaces('triggerToken', value)"
        />
      </div>

      <div class="copy_input">
        <span>{{ formData.webhookUrl }} </span>
        <div class="copy" @click="copyUrl()" :class="{ copied: !!copiedUrl }">
          {{ !!copiedUrl ? 'Copiado!' : 'Copiar URL de gatilho' }}
        </div>
      </div>

      <div class="d-flex justify-end w-100">
        <base-button @click="submitConfiguration" :loading="savingSettings"
          >Salvar</base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input.vue';
import AppBridge from '@/plugins/app';
// mixin
import deliveryConfiguration from '@/mixins/deliveryPlatformConfig.js';

// api
import DeliveryPlatformAPI from '@/api/deliveryPlatform';

import store from '@/store';

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseInput,
  },
  mixins: [deliveryConfiguration],
  data() {
    return {
      formData: {
        active: false,
        apiToken: '',
        triggerToken: '',
        webhookUrl: '',
      },
      formErrors: {
        apiToken: false,
        triggerToken: false,
      },
      copiedUrl: false,
      apiToken: '',
      triggerToken: '',
      registerValid: {
        apiToken: true,
        triggerToken: true,
      },
      savingSettings: false,
    };
  },
  async beforeMount() {
    await this.loadInitialInfo();
  },
  methods: {
    async loadInitialInfo() {
      await DeliveryPlatformAPI.getConfiguration(this.deliveryPlatform).then(
        (response) => {
          if (response.getErrors([]).length === 0) {
            const responseData = response.getData({
              credentials: {},
              active: false,
            });
            const { active, webhookUrl } = responseData;
            const { triggerToken, apiToken } = responseData.credentials || {};

            if (apiToken || triggerToken || active) {
              this.formData.active = active;
              this.formData.apiToken = apiToken;
              this.formData.triggerToken = triggerToken;
            }
            this.formData.webhookUrl = webhookUrl;
          }
        }
      );
    },
    toggle() {
      this.formData.active = !this.formData.active;
      store.commit(
        'deliveryPlatform/setTokenConfigurationIsActive',
        this.formData.active
      );
    },
    copyUrl() {
      if (!AppBridge.isApp())
        navigator.clipboard.writeText(this.formData.webhookUrl);
      else {
        AppBridge.emit('copyStoreLink', this.formData.webhookUrl);
      }
      this.copiedUrl = true;
      setTimeout(() => {
        this.copiedUrl = false;
      }, 5000);
    },
    async submitConfiguration() {
      if (this.hasErrors(this.formData)) return false;

      const bodyToRequest = {
        credentials: {
          apiToken: String(this.formData.apiToken).trim(),
          triggerToken: String(this.formData.triggerToken).trim(),
        },
        active: this.formData.active,
      };

      try {
        this.savingSettings = true;
        const response = await DeliveryPlatformAPI.putConfiguration(
          this.deliveryPlatform,
          bodyToRequest
        );

        this.savingSettings = false;
        if (response.getErrors([]).length > 0) {
          alert('Erro ao salvar as configurações');
        } else {
          this.$store.dispatch('deliveryPlatform/loadConfigurations');
          alert(StringLanguage.saveSuccess);
        }
      } catch (error) {
        this.savingSettings = false;
        alert('Erro ao salvar as configurações');
      }
    },
    hasErrors(credentials) {
      if (!credentials.apiToken || String(credentials.apiToken).length < 2)
        this.formErrors.apiToken = true;
      else this.formErrors.apiToken = false;

      if (
        !credentials.triggerToken ||
        String(credentials.triggerToken).length < 2
      )
        this.formErrors.triggerToken = true;
      else this.formErrors.triggerToken = false;

      if (this.formErrors.apiToken || this.formErrors.triggerToken) {
        alert('Preencha todos os campos obrigatórios.');
        return true;
      }
      return false;
    },
    removeEmptySpaces(field, value) {
      this.formData[field] = String(value).replaceAll(' ', '');
    },
  },
};
</script>

<style scoped>
.copy_input {
  background: #45484db8;
  border-radius: 5px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
  margin-top: 10px;
}

.copy_input span {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.copy_input .copy {
  border: 1px solid #999999;
  border-radius: 5px;
  padding: 5px 10px;
  color: var(--label-primary);
  line-height: 15px;
}

.copy_input .copy:hover {
  background: #9999993f;
  cursor: pointer;
}

.copy_input .copy.copied {
  background: #0dc59d26;
  border: 1px solid transparent;
  color: #0dc59df0;
}
</style>
